module.exports = __webpack_public_path__ + "assets/google-tag-manager-for-wordpress.37ab31cc.svg";